import script from "./TaxonomyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxonomyCard.vue?vue&type=script&setup=true&lang=js"

import "./TaxonomyCard.vue?vue&type=style&index=0&id=72703b26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72703b26"]])

export default __exports__